import { forwardRef } from 'react'
import { TextArea, TextAreaProps } from '@revolut-internal/ui-kit'
import styled from 'styled-components'

const StyledTextArea = styled(TextArea)`
  & > div {
    background: transparent !important;
  }
`

export const TransparentTextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (props, ref) => <StyledTextArea {...props} ref={ref} />,
)
